import http from './httpService';
import { apiUrl } from "../config.json";

const apiEndpoint = apiUrl + "/brandimages"

function imageUrl(id) {
    return `${apiEndpoint}/${id}`;
  }
  
  export function getImages() {
    return http.get(apiEndpoint);
  }
  
  export function getHomeImages(imageCount) {
    return http.get(`${apiEndpoint}/home/${imageCount}`);
  }

  export function getMainImage(manufacturer_id) {
    let url = `${apiEndpoint}/mainimage/${manufacturer_id}`;

    return http.get(url);
  }
  
  export function saveImage(image) {
    if (image.image_id) {
      const body = { ...image };
      delete body.image_id;
      return http.put(imageUrl(image.image_id), body);
    }
  
    return http.post(apiEndpoint, image);
  }
  
  export function deleteImage(imageId) {
    return http.delete(imageUrl(imageId));
  }

  export function deleteMainImage(brand_id) {
    let url = `${apiEndpoint}/deletemainimage/${brand_id}`;
    return http.delete(url);
  }
  